module.exports = __webpack_public_path__ + "img/navigation-menu-horizontal.943cf348.svg";